module.exports = __webpack_public_path__ + "static/media/stars-less-375.053f39aa.webp";